import store from '../store'

export const updateScopes = (token) => {
  const tokenDecodablePart = token.split('.')[1]
  const decoded = Buffer.from(tokenDecodablePart, 'base64').toString()
  const tokenJSON = JSON.parse(decoded)
  var user = store.get('user')
  user.permissions = [...tokenJSON.permissions]
}

export const updateMenuDrawer = async () => {
  const app = store.get('app')
  const user = store.get('user')
  app.hasSalesTeam = await user.checkPermission('show:salesTeam')
  app.hasAllInvoices = await user.checkPermission('show:all-invoices')
  app.hasSales = await user.checkPermission('show:sales')
  app.hasInvoices = await user.checkPermission('show:invoices')
}
